import React from "react";
import NavBar from "../NavBar";
import Footer from "../Footer";
import ForgotPasswordContent from "./ForgotPasswordContent";

function ForgotPasswordMain() {
  return (
    <div className="p-3">
      {/*Add title and metadata */}
      <title>Forgot Password</title>
      <meta name="robots" content="noindex"></meta>
      {/*navbar*/}
      <NavBar />
      {/* Body */}
      <ForgotPasswordContent />
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default ForgotPasswordMain;
